import UIActionTypes from './types'

const enableLoading = () => ({
  type: UIActionTypes.ENABLE_LOADING,
})

const disableLoading = () => ({
  type: UIActionTypes.DISABLE_LOADING,
})

const cleanUIState = () => ({
  type: UIActionTypes.UI_CLEAN_STATE,
})

const updateAlertMessage = ({ message }) => ({
  type: UIActionTypes.UPDATE_ALERT_MESSAGE,
  payload: message,
})

const gameUpdateStage = ({ stage }) => ({
  type: UIActionTypes.UPDATE_GAME_STAGE,
  payload: stage,
})

const updateImageBanner = (payload) => ({
  type: UIActionTypes.UPDATE_IMAGE_BANNER,
  payload,
})

const updateCurrentSegment = (payload) => ({
  type: UIActionTypes.UPDATE_CURRENT_SEGMENT,
  payload,
})

export { enableLoading,
  disableLoading,
  updateCurrentSegment,
  cleanUIState,
  updateAlertMessage,
  gameUpdateStage,
  updateImageBanner }



// WEBPACK FOOTER //
// ./src/entities/ui/actions.js